/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Source_DepthInputs */

const en_directory_agent_readiness_source_depth = /** @type {(inputs: Directory_Agent_Readiness_Source_DepthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source depth`)
};

const zh_directory_agent_readiness_source_depth = /** @type {(inputs: Directory_Agent_Readiness_Source_DepthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`来源深度`)
};

/**
* | output |
* | --- |
* | "Source depth" |
*
* @param {Directory_Agent_Readiness_Source_DepthInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_source_depth = /** @type {((inputs?: Directory_Agent_Readiness_Source_DepthInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Source_DepthInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_source_depth(inputs)
	return zh_directory_agent_readiness_source_depth(inputs)
});
export { directory_agent_readiness_source_depth as "directory.agent_readiness.source_depth" }